import * as tslib_1 from "tslib";
import { logUsage } from 'owa-analytics';
import onCommitThemeChange from 'owa-options-actions/lib/onCommitThemeChange';
import themeChanged from 'owa-options-actions/lib/themeChanged';
import { updateUserOptions } from 'owa-options-core';
import { getCurrentThemeId, loadTheme } from 'owa-theme';
import setUserTheme from '../services/setUserTheme';
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingTheme';
export default function commitThemeChange(themeId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var newThemeId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (themeId) {
                        loadTheme(themeId);
                    }
                    newThemeId = getCurrentThemeId();
                    onCommitThemeChange(newThemeId);
                    updateUserOptions({ ThemeStorageId: newThemeId });
                    return [4 /*yield*/, setUserTheme(newThemeId)];
                case 1:
                    _a.sent();
                    themeChanged();
                    return [2 /*return*/];
            }
        });
    });
}
export function commitQuickThemeChange(themeId) {
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [
        themeId /* What theme the user chose */,
        getCurrentThemeId() /* What theme the user is switching away from */,
    ]);
    commitThemeChange(themeId);
}
//# sourceMappingURL=commitThemeChange.js.map